import { render, staticRenderFns } from "./BlogPostingStructuredData.vue?vue&type=template&id=85a671ac"
import script from "./BlogPostingStructuredData.vue?vue&type=script&lang=js"
export * from "./BlogPostingStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports